import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {faqData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{faqData.subtitle}</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === idx ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`text-xs ${openIndex === idx ? 'ri-subtract-line text-primary-600' : 'ri-add-line text-foreground-500'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}